(() => {
  angular
    .module('gm.common.vaults', [
      'gm.common.user'
    ]);
})();
